<template>
  <!-- HTML 정의하는 부분 -->
  <!-- 1차 퍼블리셔가 작업 영역 -->
  <!-- 2차 개발자가 Template 화 작업 진행-->
  <v-container fluid>
    <v-row>
      <site-work-top-bar type="PCS" :site-info="siteInfo"></site-work-top-bar>
    </v-row>
    <v-row>
      <v-tabs v-model="tabs" height="110">
        <v-tab>
          <v-card max-width="180" height="91" class="d-flex align-center">
            <v-card-title>전체보기</v-card-title>
          </v-card>
        </v-tab>
        <v-tab v-for="(inverter, i) in inverters" :key="i">
          <v-card max-width="180" height="91" class="py-2 pl-2 pr-1">
            <v-list-item class="px-0">
              <v-list-item-content class="text-left pb-1">
                <v-list-item-title class="mb-0 font-weight-bold">{{ inverter.INVERTER_NAME }}</v-list-item-title>
                <v-list-item-subtitle>
                  <p class="my-0 caption">{{ inverter.INVERTER_MODEL }}</p>
                  <p class="my-0 caption">{{ inverter.INVETRER_OUTPUT }}KW</p>
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar
                class="rounded-circle mx-0"
                :color="
                  inverter.STATUS === 'Run'
                    ? 'green'
                    : inverter.STATUS === 'Error'
                    ? 'yellow darken-2'
                    : 'red'
                "
                size="55"
              >
                <span v-if="inverter.STATUS === 'Run'" class="round_state"
                  >Run</span
                >
                <span v-else class="round_state">Stop</span>
              </v-list-item-avatar>
            </v-list-item>
          </v-card>
        </v-tab>
      </v-tabs>
    </v-row>
    <v-row>
      <v-tabs
        fixed-tabs
        v-model="subTabs"
        @change="changeToggle = !changeToggle"
      >
        <v-tab>운전현황</v-tab>
        <v-tab>운전/정지이력</v-tab>
        <v-tab>고장정보</v-tab>
        <v-tab>MPPT별정보</v-tab>
        <v-tab-item>
          <work-state
            :tab-index="tabs"
            :s-i-t-e_-i-d="siteInfo.SITE_ID"
            :i-n-v-e-r-t-e-r_-i-d="selectInverter.INVERTER_ID"
            :s-t-a-t-i-o-n_-i-d="selectInverter.STATION_ID"
            :change-toggle="changeToggle"
          ></work-state>
        </v-tab-item>
        <v-tab-item>
          <work-record
            :tab-index="tabs"
            :s-i-t-e_-i-d="siteInfo.SITE_ID"
            :o-n-o-f-f-y-n="siteInfo.ONOFFYN"
            :i-n-v-e-r-t-e-r_-i-d="selectInverter.INVERTER_ID"
            :s-t-a-t-i-o-n_-i-d="selectInverter.STATION_ID"
          ></work-record>
        </v-tab-item>
        <v-tab-item>
          <broken-record
            :tab-index="tabs"
            :s-i-t-e_-i-d="siteInfo.SITE_ID"
            :i-n-v-e-r-t-e-r_-i-d="selectInverter.INVERTER_ID"
            :s-t-a-t-i-o-n_-i-d="selectInverter.STATION_ID"
          ></broken-record>
        </v-tab-item>
        <v-tab-item>
          <mppt-info
            :tab-index="tabs"
            :s-i-t-e_-i-d="siteInfo.SITE_ID"
            :i-n-v-e-r-t-e-r_-i-d="selectInverter.INVERTER_ID"
            :s-t-a-t-i-o-n_-i-d="selectInverter.STATION_ID"
          ></mppt-info>
        </v-tab-item>
      </v-tabs>
    </v-row>
    <general-dialog v-model="modal" :title="popupTitle" :buttons="buttons">
      <v-card flat>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="12">
                <p>마지막 비밀번호 변경후 180일이 지났습니다.</p>
                <p>비밀번호 변경을 권장드립니다. 변경하시겠습니까?</p>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </general-dialog>
  </v-container>
</template>

<script>
import { getSiteInfo } from '@/api/pcs/siteWork'
import { dateRenew } from '@/api/common/login'

import WorkState from '@/views/pc/site/WorkState'
import MpptInfo from '@/views/pc/site/MpptInfo'
import localStore from '@/utils/localStore'
import GeneralDialog from '@/components/dialogSet/GeneralDialog'
import WorkRecord from '@/views/pc/site/WorkRecord'
import BrokenRecord from '@/views/pc/site/BrokenRecord'
import SiteWorkTopBar from '@/components/monitoring/SiteWorkTopBar'

// 스크립트를 정의하는 부분
// 개발자 작업 영역
export default {
  name: 'SiteWork',
  components: {
    WorkState,
    MpptInfo,
    WorkRecord,
    BrokenRecord,
    SiteWorkTopBar,
    GeneralDialog
  },
  data() {
    return {
      changeToggle: true,
      tabs: 0,
      subTabs: 0,
      modal: false,
      popupTitle: '비밀번호 변경',
      buttons: [
        {
          title: '변경',
          color: 'primary',
          class: 'white--text',
          handler: () => {
            this.closePopup({ ok: true })
          }
        },
        {
          title: '다음에 변경하기',
          text: true,
          handler: () => {
            this.closePopup({ ok: false })
          }
        }
      ],
      inverters: [],
      weatherRes: {
        PTY: 0,
        REH: 0,
        WSD: 0,
        SKYNAME: '  ',
        T1H: '0'
      },
      siteInfo: {
        AREA: '',
        SITE_NM: '',
        SITE_ID: '',
        ONOFFYN: '',
        USER_PH: '',
        SITE_INVERTER: [
          {
            INVERTER_ID: '',
            INVERTER_MODEL: '',
            INVERTER_NAME: '',
            INVETRER_OUTPUT: '',
            SITE: '',
            STATION_ID: '',
            STATUS: ''
          }
        ]
      },
      admin: false,
      siteOn: false,
      regionOn: false,
      searchArea: false,
      interval: {}
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.

    // this.siteInfo.SITE_ID = this.$route.query.site_id
    this.init_data()
    this.startInterval()
  },
  mounted() {
    var pwChangeYN = localStore.get('pw_change')
    if (pwChangeYN === 'Y') {
      this.modal = true
    } else {
    }
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
  },
  watch: {
    tabs() {
      this.subTabs = 0
    },
    selectInverter() {
      if (this.tabs === 0) {
        this.init_data()
      }
    }
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
    selectInverter() {
      if (this.tabs !== 0) {
        return this.inverters[this.tabs - 1]
      } else {
        return {
          STATION_ID: '',
          INVERTER_ID: ''
        }
      }
    }
  },
  beforeDestroy() {
    this.stopInterval()
  },
  methods: {
    startInterval() {
      this.interval = setInterval(() => {
        this.init_data()
      }, 60000 * 2)
    },
    stopInterval() {
      clearInterval(this.interval)
    },
    init_data() {
      // 2. site_id 로 사이트정보를 조회한다 (사이트 주소 및 인버터등)
      let params = '?site_id=' + this.$route.query.site_id

      getSiteInfo(params).then(res => {
        this.siteInfo = res
        this.inverters = this.siteInfo.SITE_INVERTER
        // this.cctvBtn()
      })

      // getSiteList({}).then(res => {
      //   this.siteList = res.siteList
      //   this.siteAreaList = this.siteList.filter(d => d.AREA === '경기도')
      // })
    },
    closePopup(result) {
      if (result.ok) {
        this.modal = false
        this.$router.replace('/mypage')
      } else {
        this.modal = false
        dateRenew(localStore.get('userId'))
        localStore.set('pw_change', '')
      }
    }
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
  }
}
</script>

<style scoped>
.click_area v-btn:first-child {
  background-color: #2976d2;
}

.click_area v-btn:nth-child(2) {
  background-color: #4f9faf;
}
</style>
